<div class="question-wrapper" id="QuestionWraper">
  <input type="hidden" id="InsuranceNumber" value="0" />
  <h2 id="NoOfPolicy" class="text-center text-02-m-light text-01-d-light title">Personas a incluir en el seguro</h2>
  <div class="cj-tooltip">
    <span class="icon icon-info-line"></span>
    <p class="text-09-m-regular text-11-d-regular">
      Es importante que indiques todos los asegurados a incluir en póliza ya que las aseguradoras ofrecen precios promocionales para pólizas de más de un asegurado.
    </p>
  </div>
  <div class="form-control select">
    <div class="select-wrapper">
      <select id="NoOfPolicyInsurer" [(ngModel)]="numberOfInsurer" (change)="addDeleteInsurer(numberOfInsurer)">
        <option *ngFor="let option of question.Options" [value]="option.Value">
          {{ option.Text }}
        </option>
      </select>
    </div>
    <p class="error" id="errorNoOfPolicyInsurer">Selecciona una opción.</p>
  </div>
  <div class="" id="previousHolderDetailsWithcheckbox">
    <p class="text-07-m-demibold text-07-d-demibold text-center box-heading">
      <strong>Completa los datos</strong>
    </p>
    <div class="form-control normal-checkbox">
      <label class="normal-checkbox-container hide">
        <input type="checkbox" name="politica" id="Q5IsInsured" onclick="common.isInsurered(this)" /><!--TODO need to ask about this functionality-->
        <div class="checkmark-container">
          <span class="checkmark"></span>
          <span class="text-07-m-light text-09-d-regular">Usar los datos del titular como asegurado</span>
        </div>
      </label>
    </div>
    <div class="inner-card no-justify dataos-address-con shadow-5" id="previousHolderDetails">
      <p class="text-07-m-demibold text-07-d-demibold">Asegurado 1 - Titular</p>
      <p>{{ GenderEnum[primaryPersonType.gender] }}<br />{{ primaryPersonType.birthDate | date: 'dd/MM/yyyy' }}</p>
    </div>
  </div>

  <!-- Additional insuered  start-->

  <div id="SubTemplate" class="row question-wrapper">
    <div class="inner-card no-justify shadow-1" *ngFor="let personType of personTypes; let i = index" id="Person_{{ i }}">
      <ng-container *ngIf="personType.number !== 1">
        <p class="text-07-m-demibold text-07-d-demibold title">
          <strong>
            Asegurado
            <span id="SubTitle_1">{{ personType.number }}</span> </strong
          ><i class="icon icon-trash remove-button" (click)="removeInsurer(i)"></i>
        </p>
        <div class="row inline">
          <div class="col-xs-12 form-control">
            <label class="text-05-m-regular text-09-d-regular">{{ monthQuestion.QuestionText }}</label>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-3">
            <div class="form-control with-label input">
              <input
                type="tel"
                autocomplete="off"
                [(ngModel)]="personType.dateOption.day"
                name="Insurer_Day"
                id="Insurer_{{ i }}_Day"
                min="1"
                max="31"
                placeholder="Día"
                class="text-input inline text-09-d-demibold"
                pattern="[0-9]*"
                (keypress)="numberOnly($event)"
                (keyup)="onDayKeyUp(personType.dateOption)"
                maxlength="2"
                [class.error]="!validDateOptions[i].isValidDay" />
            </div>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-6">
            <div class="form-control with-label select" [class.error]="!validDateOptions[i].isValidMonth">
              <div class="select-wrapper">
                <select class="inline" name="Insurer_Month" [(ngModel)]="personType.dateOption.month" id="Insurer_{{ i }}_Month" style="color: rgb(1, 83, 104)">
                  <option *ngFor="let month of monthQuestion.Options" [value]="month.Value">
                    {{ month.Text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-3">
            <div class="form-control with-label input">
              <input
                type="tel"
                autocomplete="off"
                [(ngModel)]="personType.dateOption.year"
                name="Insurer_Year"
                id="Insurer_{{ i }}_Year"
                min="1"
                placeholder="Año"
                class="text-input inline text-09-d-demibold"
                pattern="[0-9]*"
                (keypress)="numberOnly($event)"
                maxlength="4"
                [class.error]="!validDateOptions[i].isValidYear" />
            </div>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-12 error date day" id="errorDay{{ i }}">
            <div [hidden]="validDateOptions[i].isValidDay">
              {{ sWErrorMessage.invalidDay }}
            </div>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-12 error date month" id="errorMonth{{ i }}">
            <div [hidden]="validDateOptions[i].isValidMonth">
              {{ sWErrorMessage.invalidMonth }}
            </div>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-12 error date year" id="errorYear{{ i }}">
            <div [hidden]="validDateOptions[i].isValidYear">
              {{ sWErrorMessage.invalidYear }}
            </div>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12 error date2" id="errorDate{{ i }}">
            <p class="local-row-p" id="errorMsgDate{{ i }}">
              {{ validDateOptions[i].errorMessage }}
            </p>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Additional insuered  end-->

  <div class="add-button">
    <button class="btn with-icon" id="btnAddInsurer" (click)="addNewInsurer()">
      <div class="btn-wrapper"><span class="icon icon-add"></span>Añadir asegurado</div>
    </button>
  </div>
</div>

<button id="btnClose" class="btn solid-main" (click)="saveSectionAnswer()">Guardar</button>
